<template lang="pug">
.wrapper
  banner(:bannerList="bannerList")
  .pt-2.pb-5.bg-light
    .container
      b-tabs.mb-5(v-model="currentTabIndex")
        ul.nav.nav-tabs.mb-3
          li.nav-item
            b-tab(title="Announcement", active="")
          li.nav-item
            b-tab(title="News")
        form.d-none.d-sm-block.showing
          .form-group.row
            label.col-sm-4.col-form-label.d-none.d-sm-block Showing
            .col-sm-6
              select.form-control.form-control-sm(v-model="currentNewsYear")
                option(
                  v-for="(year, index) in currentNewsYearList",
                  :value="year"
                ) {{ year }}
      form.d-block.d-sm-none
        .form-group.row.justify-content-end
          .col-4
            select.form-control.form-control-sm(v-model="currentNewsYear")
              option(
                v-for="(year, index) in currentNewsYearList",
                :value="year"
              ) {{ year }}
      news-item(
        v-for="(news, index) in currentPageNewsList",
        :key="index",
        :news="news",
        style="cursor: pointer",
        @click.native="toDetail(news.id)"
      )
      b-pagination.pagination-sm.justify-content-end.mb-5(
        v-model="currentPage",
        :total-rows="pages",
        :per-page="perPage",
        first-number,
        last-number,
        prev-text="Previous",
        next-text="Next"
      )
      .title-bar.my-4
        h2 Events & Headlines
        form.showing
          .form-group.row
            label.col-sm-4.col-form-label.d-none.d-sm-block Showing
            .col-sm-6
              select.form-control.form-control-sm(v-model="eventHeadlineYear")
                option(
                  v-for="(year, index) in yearFilter.event_headline_years",
                  :value="year"
                ) {{ year }}
      events(:type="'event_headline'", :eventList="eventHeadlineList")
      .title-bar.my-4
        h2 Videos
        events(:type="'video'", :eventList="videoList")
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
</template>

<script>
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import Banner from "@/components/ic_selector/Banner";
import Events from "@/components/news/Events";
import NewsItem from "@/components/news/NewsItem";
import {
  getYearFilter,
  getEventHeadlineList,
  getVideos,
  getAnnouncementList,
  getPressReleaseList,
} from "@/api/news";
import { getBannerList } from "@/api/company";

export default {
  name: "News",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
    banner: Banner,
    Events,
    NewsItem,
  },
  data() {
    return {
      bannerList: [],
      yearFilter: {},

      eventHeadlineYear: "",
      eventHeadlineList: [],

      videoList: [],

      currentTabIndex: 0,
      currentNewsYearList: [],
      currentNewsYear: "",
      currentPageNewsList: [],

      pages: 1,
      perPage: 4,
      currentPage: 1,

      metaData: {
        title: "News & Announcement ｜EETI – Empower TouchSystem",
      },
    };
  },
  watch: {
    eventHeadlineYear() {
      this.getEventHeadlineList();
    },
    currentTabIndex() {
      this.currentPage = 1;
      this.checkCurrentTab();
    },
    currentPage() {
      if (this.currentTabIndex == 0) {
        this.getAnnouncementList();
      } else {
        this.getPressReleaseList();
      }
    },
    currentNewsYear() {
      if (this.currentTabIndex == 0) {
        this.getAnnouncementList();
      } else {
        this.getPressReleaseList();
      }
    },
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
    this.getVideos();
  },
  methods: {
    initialLanguage() {
      this.getBannerList();
      this.getYearFilter();
    },
    getBannerList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getBannerList(temp).then((response) => {
        this.bannerList = response.data;
      });
    },
    getYearFilter() {
      getYearFilter().then((response) => {
        this.yearFilter = response.data;

        if (
          this.yearFilter &&
          this.yearFilter.event_headline_years &&
          this.yearFilter.event_headline_years.length > 0
        ) {
          this.eventHeadlineYear = this.yearFilter.event_headline_years[0];
        }

        if (this.$route.params.type == "press_release") {
          this.currentTabIndex = 1;
        }

        this.checkCurrentTab();
      });
    },
    getEventHeadlineList() {
      let params = {
        lang: this.$store.state.user.language,
        year: this.eventHeadlineYear,
      };
      getEventHeadlineList(params).then((response) => {
        this.eventHeadlineList = response.data;
      });
    },
    getVideos() {
      getVideos().then((response) => {
        this.videoList = response.data;
      });
    },
    getAnnouncementList() {
      let params = {
        lang: this.$store.state.user.language,
        year: this.currentNewsYear,
        page: this.currentPage,
        page_size: this.perPage,
      };
      getAnnouncementList(params).then((response) => {
        this.currentPageNewsList = response.data.results;
        this.pages = response.data.count;
      });
    },
    getPressReleaseList() {
      let params = {
        lang: this.$store.state.user.language,
        year: this.currentNewsYear,
        page: this.currentPage,
        page_size: this.perPage,
      };
      getPressReleaseList(params).then((response) => {
        this.currentPageNewsList = response.data.results;
        this.pages = response.data.count;
      });
    },
    checkCurrentTab() {
      if (this.currentTabIndex == 0) {
        this.currentNewsYearList = this.yearFilter.announcement_years;
        if (
          this.yearFilter &&
          this.yearFilter.announcement_years &&
          this.yearFilter.announcement_years.length > 0
        ) {
          this.currentNewsYear = this.yearFilter.announcement_years[0];
          this.getAnnouncementList();
        }
      } else {
        this.currentNewsYearList = this.yearFilter.press_release_years;
        if (
          this.yearFilter &&
          this.yearFilter.press_release_years &&
          this.yearFilter.press_release_years.length > 0
        ) {
          this.currentNewsYear = this.yearFilter.press_release_years[0];
          this.getPressReleaseList();
        }
      }
    },
    toDetail(id) {
      let type;
      if (this.currentTabIndex == 0) {
        type = "announcement";
      } else {
        type = "press_release";
      }
      this.$router.push({
        name: "NewsDetail",
        query: {
          type: type,
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/nav_tab";
@import "@/assets/style/common/pagination";
@import "@/assets/style/news/news";
</style>
